// Salesforce REST query responses are delivered in batches of at least 200 records.
export const SALESFORCE_BATCH_SIZE = 200;

export const getSalesforceBatchWindow = (page, pageSize) => {
  const firstRecordIndex = (page - 1) * pageSize;

  return {
    batchIndex: Math.floor(firstRecordIndex / SALESFORCE_BATCH_SIZE),
    offset: firstRecordIndex % SALESFORCE_BATCH_SIZE,
  };
};
